import React from 'react';
import I18n from 'utils/I18n';
import { ActionsCheckCircleOnXsmall } from '@strava/icons';
import { useCheckoutContext } from '../../../state/CheckoutContext';
import { I18nPrefixTrial, I18nPrefixFatmap } from '../../../shared/constants';

import styles from './SubscriptionFeatures.scss';

const SubscriptionFeatures = () => {
  const { checkoutEntityState } = useCheckoutContext();
  const { analyticsData } = checkoutEntityState;

  const isFromFatmap = analyticsData.origin === 'fatmap';

  const features = isFromFatmap ? ([
    {
      description: I18n.t(`${I18nPrefixFatmap}.strava`)
    },
    {
      description: I18n.t(`${I18nPrefixFatmap}.fatmap`)
    },
    {
      description: I18n.t(`${I18nPrefixFatmap}.recover`)
    }
  ]) : ([
    {
      description: I18n.t(`${I18nPrefixTrial}.feature_route`)
    },
    {
      description: I18n.t(`${I18nPrefixTrial}.feature_analysis_v2`)
    },
    {
      description: I18n.t(`${I18nPrefixTrial}.feature_segment_v2`)
    },
    {
      description: I18n.t(`${I18nPrefixTrial}.recover`),
      link: 'https://recoverathletics.com/',
      badge: I18n.t(`${I18nPrefixTrial}.new_badge`),
    },
    {
      description: I18n.t(`${I18nPrefixTrial}.fatmap`),
      link: 'https://www.fatmap.com/',
      badge: I18n.t(`${I18nPrefixTrial}.new_badge`),
    }
  ]);

  return (
    <ul className={styles.subscriptionFeatures}>
      {features.map((feature) => (
        <li
          className={styles.featureItem}
          key={feature.description}
        >
          <div className={styles.featureItemIconContainer}>
            <ActionsCheckCircleOnXsmall />
          </div>
          {feature.link ? (
            <a
              className={styles.underline}
              href={feature.link}
              target="_blank"
              rel="noopener noreferrer">
              <span>{feature.description}</span>
            </a>
          ) : (
            <span>{feature.description}</span>
          )}
          {feature.badge && (
            <span className={styles.badge}>
              {feature.badge.toUpperCase()}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default SubscriptionFeatures;
